import { RouterProvider } from '@tanstack/react-router'
import { router } from './routes'
import { Provider as JotaiProvider } from 'jotai'

function App() {
  return (
    <JotaiProvider>
      <RouterProvider router={router} />
    </JotaiProvider>
  )
}

export default App
